import { createContext, useState, useEffect, useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import AuthService from "../services/LoginService/auth.service";
import userService from "services/userServices/user.service";

const PERMISOS_NO_DISPONIBLES = "No fue posible consultar tus permisos";

const leerUsuarioGuardado = () => {
    try {
        const parsed = JSON.parse(localStorage.getItem("userdata"));
        return parsed && typeof parsed === "object" ? parsed : null;
    } catch {
        return null;
    }
};

// Los permisos que quedaron en el navegador no conceden nada: se descartan al
// arrancar y solo valen los que responda el servidor en esta sesion. Si no se
// borraran, revocar un modulo no tendria efecto hasta cerrar sesion.
const sinPermisosGuardados = (almacenado) => {
    if (!almacenado) return null;
    const { modulos, moduleKeys, ...resto } = almacenado;
    return resto;
};

export const AuthContext = createContext({
    isAuthenticated: false,
    user: null,
    permissionsLoading: false,
    permissionsError: "",
    refreshPermissions: () => { },
    login: () => { },
    logout: () => { },
    limpiarLocal: () => { },
});


const AuthContextProvider = ({ children }) => {

    const navigate = useNavigate();
    const location = useLocation();
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [user, setUser] = useState(() => sinPermisosGuardados(leerUsuarioGuardado()));
    const [permissionsLoading, setPermissionsLoading] = useState(() => Boolean(leerUsuarioGuardado()));
    const [permissionsError, setPermissionsError] = useState("");
    const [permissionsNonce, setPermissionsNonce] = useState(0);

    const isValidToken = (token) => {
        if (!token) return false;
        const normalized = token.toString().trim().toLowerCase();
        return !["undefined", "null", "nan", "[object object]", ""].includes(normalized);
    };

    const refreshPermissions = useCallback(() => {
        setPermissionsNonce((nonce) => nonce + 1);
    }, []);

    // if (token == "undefined" || token == "null" || token == null) {
    //     localStorage.removeItem("userdata");
    //     localStorage.removeItem("token");
    // }

    // useEffect(() => {
    //     if (!token) {
    //         if (!location.pathname == "auth/reset-password") {
    //             limpiarLocal();
    //         }
    //     }
    // }, [token]);

    // Una sesion abierta consulta sus permisos en cada arranque y cada vez que
    // se pidan de nuevo. El id es la identidad: cambiar de usuario recarga.
    const userId = user?.USU_NID;

    useEffect(() => {
        if (!userId) {
            setPermissionsLoading(false);
            return undefined;
        }

        let vigente = true;
        setPermissionsLoading(true);
        setPermissionsError("");

        userService
            .getPermissions()
            .then((response) => {
                if (!vigente) return;
                const data = response?.data;
                if (!data || !Array.isArray(data.moduleKeys)) {
                    setPermissionsError(response?.error || response?.message || PERMISOS_NO_DISPONIBLES);
                    return;
                }
                setUser((previo) => {
                    const siguiente = {
                        ...(previo || {}),
                        modulos: Array.isArray(data.modulos) ? data.modulos : [],
                        moduleKeys: data.moduleKeys,
                    };
                    try {
                        localStorage.setItem("userdata", JSON.stringify(siguiente));
                    } catch {
                        // Sin almacenamiento la sesion sigue viva en memoria.
                    }
                    return siguiente;
                });
            })
            .catch((error) => {
                if (vigente) setPermissionsError(error?.message || PERMISOS_NO_DISPONIBLES);
            })
            .finally(() => {
                if (vigente) setPermissionsLoading(false);
            });

        return () => {
            vigente = false;
        };
    }, [userId, permissionsNonce]);

    useEffect(() => {
        if (user) {
            if (location.pathname === "/auth/sign-in") {
                navigate("/admin/default");
            }
        }
    }, [user, location.pathname, navigate]);

    const login = async (token, refresh_token, userInfo) => {
        if (isValidToken(token)) {
            localStorage.setItem("token", token.toString().trim());
            sessionStorage.setItem("token", token.toString().trim());
        }
        // El Login ya responde con los modulos vigentes; el efecto los vuelve a
        // pedir de todas formas, por si cambiaron entre peticiones.
        setPermissionsError("");
        setUser(userInfo);
        localStorage.setItem("userdata", JSON.stringify(userInfo));
        setIsAuthenticated(true);
        navigate("/admin/default");
    };

    const limpiarLocal = () => {
        setIsAuthenticated(false);
        setUser(null);
        setPermissionsError("");
        setPermissionsLoading(false);
        const keysToRemove = ["userdata", "token", "lastActivity", "isLoggedOut", "logout","PaginaActual"];
        keysToRemove.forEach(key => localStorage.removeItem(key));
        navigate("/auth/sign-in", { replace: true });
    };

    const logout = async () => {
        if (user) {
            await AuthService.Logout({usuario: user});
        }
        limpiarLocal();
    };

    return (
        <AuthContext.Provider
            value={{
                isAuthenticated, user, login, logout, limpiarLocal,
                permissionsLoading, permissionsError, refreshPermissions,
            }}
        >
            {children}
        </AuthContext.Provider>
    );
};

// // Contexto para datos JSON
// export const DataContext = createContext({
//     datamodulogestion: null,
//     setdatamodulogestion: () => { },
// });

// const DataProvider = ({ children }) => {
//     const [datamodulogestion, setdatamodulogestion] = useState(null);

//     return (
//         <DataContext.Provider value={{ datamodulogestion, setdatamodulogestion }}>
//             {children}
//         </DataContext.Provider>
//     );
// };

// // Setting custom name for the context which is visible on react dev tools
// MaterialUI.displayName = "MaterialUIContext";

// // Material Dashboard 2 React reducer
// function reducer(state, action) {
//     switch (action.type) {
//         case "MINI_SIDENAV": {
//             return { ...state, miniSidenav: action.value };
//         }
//         case "TRANSPARENT_SIDENAV": {
//             return { ...state, transparentSidenav: action.value };
//         }
//         case "WHITE_SIDENAV": {
//             return { ...state, whiteSidenav: action.value };
//         }
//         case "SIDENAV_COLOR": {
//             return { ...state, sidenavColor: action.value };
//         }
//         case "TRANSPARENT_NAVBAR": {
//             return { ...state, transparentNavbar: action.value };
//         }
//         case "FIXED_NAVBAR": {
//             return { ...state, fixedNavbar: action.value };
//         }
//         case "OPEN_CONFIGURATOR": {
//             return { ...state, openConfigurator: action.value };
//         }
//         case "DIRECTION": {
//             return { ...state, direction: action.value };
//         }
//         case "LAYOUT": {
//             return { ...state, layout: action.value };
//         }
//         case "DARKMODE": {
//             return { ...state, darkMode: action.value };
//         }
//         default: {
//             throw new Error(`Unhandled action type: ${action.type}`);
//         }
//     }
// }

// // Material Dashboard 2 React context provider
// function MaterialUIControllerProvider({ children }) {
//     const initialState = {
//         miniSidenav: false,
//         transparentSidenav: false,
//         whiteSidenav: false,
//         sidenavColor: "info",
//         transparentNavbar: true,
//         fixedNavbar: true,
//         openConfigurator: false,
//         direction: "ltr",
//         layout: "dashboard",
//         darkMode: false,
//         ecopetrolMode: true,
//     };

//     const [controller, dispatch] = useReducer(reducer, initialState);

//     const value = useMemo(() => [controller, dispatch], [controller, dispatch]);

//     return <MaterialUI.Provider value={value}>{children}</MaterialUI.Provider>;
// }

// // Material Dashboard 2 React custom hook for using context
// function useMaterialUIController() {
//     const context = useContext(MaterialUI);

//     if (!context) {
//         throw new Error(
//             "useMaterialUIController should be used inside the MaterialUIControllerProvider."
//         );
//     }

//     return context;
// }

// // Typechecking props for the MaterialUIControllerProvider
// MaterialUIControllerProvider.propTypes = {
//     children: PropTypes.node.isRequired,
// };

// // Context module functions
// const setMiniSidenav = (dispatch, value) =>
//     dispatch({ type: "MINI_SIDENAV", value });
// const setTransparentSidenav = (dispatch, value) =>
//     dispatch({ type: "TRANSPARENT_SIDENAV", value });
// const setWhiteSidenav = (dispatch, value) =>
//     dispatch({ type: "WHITE_SIDENAV", value });
// const setSidenavColor = (dispatch, value) =>
//     dispatch({ type: "SIDENAV_COLOR", value });
// const setTransparentNavbar = (dispatch, value) =>
//     dispatch({ type: "TRANSPARENT_NAVBAR", value });
// const setFixedNavbar = (dispatch, value) =>
//     dispatch({ type: "FIXED_NAVBAR", value });
// const setOpenConfigurator = (dispatch, value) =>
//     dispatch({ type: "OPEN_CONFIGURATOR", value });
// const setDirection = (dispatch, value) =>
//     dispatch({ type: "DIRECTION", value });
// const setLayout = (dispatch, value) => dispatch({ type: "LAYOUT", value });
// const setDarkMode = (dispatch, value) => dispatch({ type: "DARKMODE", value });

export {
    AuthContextProvider,
    // DataProvider,
    // MaterialUIControllerProvider,
    // useMaterialUIController,
    // setMiniSidenav,
    // setTransparentSidenav,
    // setWhiteSidenav,
    // setSidenavColor,
    // setTransparentNavbar,
    // setFixedNavbar,
    // setOpenConfigurator,
    // setDirection,
    // setLayout,
    // setDarkMode,
};
